import api from 'pages/open-course/common/api';

import type { QuizQuestionPrompt } from 'bundles/compound-assessments/types/FormParts';
import type { InVideoQuestion } from 'bundles/video-quiz/types';

export type VideoQuizData = {
  sessionId: string;
  questions: InVideoQuestion<QuizQuestionPrompt>[];
};

async function getVideoQuizData(
  courseSlug: string,
  videoItemId: string,
  userId: number
): Promise<VideoQuizData | null> {
  const session = await api
    .post(`user/${userId}/course/${courseSlug}/item/${videoItemId}/lecture/inVideoQuiz/session`, {
      data: {
        contentRequestBody: {},
      },
    })
    .then((res) => res.contentResponseBody.session);

  if (!session.id) {
    return null;
  }

  const questions = await api
    .post(
      `user/${userId}/course/${courseSlug}/item/${videoItemId}/lecture/inVideoQuiz/session/${session.id}/action/getQuestions`,
      {
        data: {
          contentRequestBody: { argument: {} },
        },
      }
    )
    .then((res) => res.contentResponseBody.return.questions);

  return {
    sessionId: session.id,
    questions: questions as InVideoQuestion<QuizQuestionPrompt>[],
  };
}

export default getVideoQuizData;

// https://www.coursera.org/api/opencourse.v1/user/43529816/course/success/item/ziz80/lecture/inVideoQuiz/session/opencourse~jnxgv1sXEea6OBIvyzcuGw:43529816:uX2bRC50Eeeo2w7QMCMBzg@4:1686846670001@1/action/getQuestions?autoEnroll=false
